// API-клиент: fetch с credentials (сессионный cookie) + базовые ошибки.
// Типы — из ./schema.d.ts (генерируется `bun run openapi`).
//
// Использование с TanStack Query:
//   const { data } = useQuery({ queryKey: ['projects'], queryFn: () => api.get('/projects') });

export class ApiError extends Error {
  constructor(public status: number, message: string, public detail?: unknown) {
    super(message);
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
    ...init,
  });
  if (!res.ok) {
    let detail: unknown;
    try { detail = await res.json(); } catch {}
    throw new ApiError(res.status, `HTTP ${res.status}`, detail);
  }
  // 204 No Content
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}

export const api = {
  get:    <T>(path: string)               => request<T>(path),
  post:   <T>(path: string, body?: unknown) => request<T>(path, { method: 'POST', body: body != null ? JSON.stringify(body) : undefined }),
  patch:  <T>(path: string, body?: unknown) => request<T>(path, { method: 'PATCH', body: body != null ? JSON.stringify(body) : undefined }),
  delete: <T>(path: string)               => request<T>(path, { method: 'DELETE' }),
};

// Telemetry-прокси для legacy /static/js/telemetry.js (если загружен в окне)
export function track(event: string, payload: Record<string, unknown> = {}, extra: Record<string, unknown> = {}) {
  try {
    const w = window as unknown as { Telemetry?: { track: (e: string, p: object, x: object) => void } };
    if (w.Telemetry && typeof w.Telemetry.track === 'function') {
      w.Telemetry.track(event, payload, extra);
    }
  } catch { /* swallow */ }
}
